import * as users from "mortar/endpoints/users";

export const getUserSignature = () => users.getUserSignatureSelf();

export const uploadUserSignature = (
  data: users.UploadUserSignatureImageActionFormData
) => users.uploadUserSignatureImageSelf({ formParams: data });
